import { DashboardComponent } from './../../dashboard/dashboard.component';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CardBarCodeComponent } from './../../../shared/card-barcode/card-barcode.component';
import { take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-I',
    templateUrl: './rs005-card-I.component.html'
})

export class Rs005CardIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listSiteRecebimentoOriginal?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listHouveTrocaCaixa?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listNumeroCaixa?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public filteredOptionsSiteRecebimento: Observable<DropDownListSiteRecebimentoDTO[]>;
    public disableBtnCerar: boolean;
    public isNovaCaixa: boolean = false;
    public _scannerIsRunning: boolean;
    public _scannerCerarCode: string;
    public disableNumeroCampo: boolean = false;
    public safraBasicaOld = ''
    @Output() objGetData = new EventEmitter();
    DashboardComponent: any;

    @Output() objSetSoruce = new EventEmitter();
    setSoruce: any;

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
        super('Dados do CERAR', false);
        if (this.isBasica || this.isComercial) {
            this.formulario = this.formBuilder.group({
                Cerar: [null, [Validators.required]],
                Site_recebimento: [null, [Validators.required]],
                Safra: [null, [Validators.pattern(this.regexSafra)]],
                Data_despalha: [null, [Validators.pattern(this.regexDate)]],
                Hibrido_rnc: [null, []],
                Gleba: [null, []],
                Contrato_juridico: [null, []],
                Nr_campo: [null, []],
                Peso_liq_carga_cooperante_kg: [null, []],
                Peso_amostra_cooperante_g: [null, []],
                Peso_palha_cooperante_g: [null, []],
                Peso_impureza_cooperante_g: [null, []],
                Peso_sabugo_cooperante_g: [null, []],
                Peso_semente_cooperante_g: [null, []],
                Umidade: [null, []],
            });
        }
        else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                site_recebimento: [null, [Validators.required]],
                safra: [null, [Validators.required]],
                safra_basica: [null, [Validators.required, Validators.pattern(this.regexSafraPreBasica)]],
                cerar_basica: [null, [Validators.required]],
                numero_campo: [null, [Validators.required]],
                gleba: [null, []],
                geracao: [null, [Validators.required]],
                numero_caixa: [null, [Validators.required]],
                lote_rw: [null, [Validators.required]],
                hibrido_rnc: [null, [Validators.required]],
                tipo_colheita: ['Manual', [Validators.required]],
                contrato_juridico: [null, [Validators.required]],
                site_origem: ['PET', [Validators.required]],
                peso_rw: [null, [Validators.required]],
                peso_pos_secagem: [null, [Validators.required]],
                houve_troca_caixa: [null, [Validators.required]],
                novo_numero_caixa: [null, []],
                nota_granacao: [null, []],
                nota_ardida: [null, []],
                controle_caixa: [null, []]
            });
        }

    }

    public async ngOnInit(): Promise<void> {
        if (this.isComercial || this.isBasica) {
            this.formulario.get('Cerar').setErrors({ invalidCerar: false });
        }
        this.listSiteRecebimento = new Array<DropDownListSiteRecebimentoDTO>();
        await this.checkBtnLeitorEnable();
        await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await Promise.all([this.getListSiteRecebimento(), this.getListHouveTrocaCaixa()])
    }

    async getListSiteRecebimento(): Promise<void> {
        this.listSiteRecebimento = this.generalService.getListSiteRecebimento();
        this.listSiteRecebimentoOriginal = this.listSiteRecebimento;
    }

    async createFilterSiteRecebimento(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listSiteRecebimentoOriginal.filter(x => x.initials?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listSiteRecebimento = this.listSiteRecebimentoOriginal.filter(x => x.initials?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listSiteRecebimento = this.listSiteRecebimentoOriginal;
            }
        } else {
            this.listSiteRecebimento = this.listSiteRecebimentoOriginal;
        }
        // this.filteredOptionsSiteRecebimento = this.formulario.get('Site_recebimento').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownListSiteRecebimento(this.listSiteRecebimento, value))
        //     );
    }

    async openDialog(): Promise<void> {
        await this.checkBtnLeitorDisable();
        const dialogRef = this.dialog.open(CardBarCodeComponent, {
            width: '670px',
            height: '700px',
            data: {
                field: 'Cerar',
            }
        });
        dialogRef.afterClosed().subscribe(async data => {
            await this.checkBtnLeitorEnable();
            this.formulario.get('Cerar').setValue(data);
            await this.getDataFromCerar();
        });
    }

    async checkBtnLeitorDisable(): Promise<void> {
        this.disableBtnCerar = true;
    }

    async checkBtnLeitorEnable(): Promise<void> {
        this.disableBtnCerar = false;
    }

    public async getDataFromCerar(): Promise<void> {
        await this.checkCerarExist();
        const cerar = this.formulario.get('Cerar')?.value as string ?? '';
        if (!!cerar) {
            this.objGetData.emit(cerar);
        }
    }

    async checkCerarExist(): Promise<void> {
        const cerar: string = this.formulario.get('Cerar')?.value;
        await this.formularioService.checkValueExists('cerar', 'rs005', cerar).pipe(take(1)).toPromise().then(async (response: any) => {
            if (!!response?.data) {
                if ((response.data as boolean) === true) {
                    this.formulario.get('Cerar').setErrors({ invalidCerar: true });;
                    this.notificationService.sendNotification(`O Cerar ${cerar} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
                } else {
                    this.formulario.get('Cerar').setErrors({ invalidCerar: false });
                    this.formulario.get('Cerar').updateValueAndValidity();
                }
            }
        }).catch(async (error: HttpErrorResponse) => {

        });
    }

    changeSafra(event: any): void {
        this.converterSafra();
        this.getFieldsSec002(null);
    }
    converterSafra() {
        const safraBasica = (this.formulario.get('safra_basica')?.value as string)?.toUpperCase()
        const prefix = safraBasica.substring(0, 2); // Pega o prefixo (IN ou VE)
        const year = safraBasica.substring(3); // Pega o ano (22)
        if ((!safraBasica.includes('INV') && !safraBasica.includes('VER'))) {
            this.formulario.get('safra_basica')?.setErrors({ pattern: false })
            this.formulario.get('safra_basica').updateValueAndValidity()

            return
        }
        this.formulario.get('safra')?.setValue(`${prefix}${year}`)


        this.formulario.get('safra_basica')?.setValue(safraBasica)

        this.formulario.get('safra_basica')?.setErrors({ pattern: true })
        this.formulario.get('safra_basica').updateValueAndValidity()

        if (safraBasica != "" || safraBasica != null) {

            this.disableNumeroCampo = this.safraBasicaOld == safraBasica
        }

    }
    getFieldsSec002(event: any): void {
        const safra_basica = this.formulario?.get('safra_basica').value;
        const numero_campo = this.formulario?.get('numero_campo').value;
        const cerar = this.formulario?.get('cerar_basica').value
        const safra = this.formulario?.get('safra').value
        // if (this.formulario?.get('safra').value &&
        //     safra_basica &&
        //     cerar) {
        //     this.formularioService.getGlebaFromSec002ByCerarAndSafra(this.formulario?.get('safra_basica').value, this.formulario?.get('cerar_basica').value).pipe(take(1)).toPromise().then(result => {
        //         this.formulario?.get('gleba').setValue(result.data.gleba);
        //     })
        // }

        if (safra &&
            safra_basica &&
            numero_campo &&
            cerar) {

            this.formularioService.getDataFromSec002ByNumCampoAndSafra(safra_basica, numero_campo, cerar).pipe(take(1)).toPromise().then(result => {
                if (result.data) {
                    this.formulario?.get('gleba').setValue(result.data.gleba);
                    this.formulario?.get('contrato_juridico').setValue(result.data.contrato_campo);
                    this.formulario?.get('geracao').setValue(result.data.geracao_basica);
                    this.formulario?.get('hibrido_rnc').setValue(result.data.hibrido_rnc_linhagem);
                    this.formulario?.get('lote_rw').setValue(result.data.lote_rw);
                    this.formulario?.get('nota_ardida').setValue(result.data.nota_ardida);
                    this.listNumeroCaixa = this.generalService.orderByDropDownList(
                        result.data.numero_caixas as DropDownListDTO[]
                    )
                }
                else {
                    this.listNumeroCaixa = []
                    this.formulario?.get('numero_caixa').setValue(null);
                    this.formulario?.get('gleba').setValue(null);
                    this.formulario?.get('contrato_juridico').setValue(null);
                    this.formulario?.get('geracao').setValue(null);
                    this.formulario?.get('hibrido_rnc').setValue(null);
                    this.formulario?.get('lote_rw').setValue(null);
                    this.formulario?.get('nota_ardida').setValue(null);
                    this.formulario?.get('controle_caixa').setValue(null);
                    this.formulario?.get('peso_pos_secagem').setValue(null);
                    this.formulario?.get('peso_rw').setValue(null);
                }

            });

        }



    }


    async getListHouveTrocaCaixa(): Promise<void> {
        await this.formularioService
            .getListDropDownList('rs005', 'houve_troca_caixa')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listHouveTrocaCaixa = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    )
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }

    changeCaixa() {
        const safra_basica = this.formulario?.get('safra_basica').value;
        const numero_campo = this.formulario?.get('numero_campo').value;
        const numero_caixa = this.formulario?.get('numero_caixa').value;

        this.formularioService.getPesoPosSecagemSec002(safra_basica, numero_campo, numero_caixa).pipe(take(1)).toPromise().then(result => {
            this.formulario?.get('controle_caixa').setValue(result.data.controle_caixa);
            this.formulario?.get('peso_pos_secagem').setValue(result.data.peso_pos_secagem);
            this.formulario?.get('peso_rw').setValue(result.data.peso_rw_kg_total);
            const objEmit = {
                result,
                pesoPosSecagem: this.formulario?.get('peso_pos_secagem').value
            }
            this.objSetSoruce.emit(objEmit);

        })



    }
    onChangeNovaCaixa($event) {
        if (this.formulario?.get('houve_troca_caixa').value === 'SIM') {
            this.isNovaCaixa = true;
        }
        else {

            this.formulario?.get('novo_numero_caixa').setValue(null);
            this.isNovaCaixa = false;
        }
    }


    async checkNumeroCampo() {
        const site = this.formulario.get('site_recebimento')?.value
        const safra = this.formulario.get('safra_basica')?.value
        const numeroCampo = this.formulario.get('numero_campo')?.value
        if (!site || !safra || !numeroCampo || this.disableNumeroCampo) {
            return
        }
        this.formularioService.checkNumeroCampo('rs005', {
            filters: {
                numero_campo: String(numeroCampo),
                site_recebimento: site as string,
                safra_basica: safra as string
            }
        }).pipe(take(1)).toPromise().then((response: any) => {

            if ((response.data as boolean) === true) {
                this.formulario.get('numero_campo').setErrors({ invalidExist: true });;
                this.notificationService.sendNotification(`O Numero do campo ${numeroCampo} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
            } else {
                this.formulario.get('numero_campo').setErrors({ invalidExist: false });
                this.formulario.get('numero_campo').updateValueAndValidity();

            }

        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
}
